import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  //   background-color: ${theme.darkGreyBg};
  padding: 30px 0;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
`;

export const QnaSection = styled.div<{ index: number }>`
  ${(props) => `
        &:nth-child(n+3) {
            border-top: 1px solid #979797;
            padding-top: 30px;
        }
    `}
`;

export const Question = styled.h3`
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 25px;
  color: ${theme.blackText};
`;

export const Answer = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: ${theme.greyText};
`;
